export const colors = {
  darkPurple: "#0e0e52",
  brightBlue: "#3B4BDD",
  darkBlue: "#2249aa",
  palePink: "#F8D0FC",
  paleGreen: "#B2EED1",
  correctGreen: "#C7FFC6",
  falseRed: "#FFA9A9",
  paleBlue: "#B4EAF6",
  darkGrey: "#2B2D39",
  grey: "#828282",
  lightBlue: "#F6F6F6",
  lightGrey: "#E5E7FA",
  white: "#fff"
};
